import Repository, {
  ExtendedAxiosRequestConfig,
} from "@shared/services/api/abstracts/Repository";
import { PublicBaseSeatPermissionsV2Serializer } from "../types/seating-types";

export default class PublicBasedTTSeatPermissionsV2Repository extends Repository<PublicBaseSeatPermissionsV2Serializer> {
  public readonly repositoryName = "PublicBasedTTSeatPermissionsV2Repository";

  public readonly endpoint =
    "/api/public/events/ticket-types/seat-permissions/v2/";

  public async getPermissions(config: ExtendedAxiosRequestConfig) {
    const { data } = await this.request(this.buildUrl(), config);
    return data;
  }
}
